import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import grey from '@material-ui/core/colors/grey';
// import SonnyCondRegular from './fonts/SonnyGothicCondensed/SonnyCond-Regular.woff2';
// import PromptRegular from './fonts/Prompt/Prompt-Regular.ttf';

// const engUnicodeRange = `
//   U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F,
//   U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD
// `;
// const thaiUnicodeRange = `
//   U+0E01-0E5B, U+200C-200D, U+25CC, U+00E3F
// `;

// const sonnyCondRegular = {
//   fontFamily: 'SonnyCond',
//   fontStyle: 'normal',
//   fontDisplay: 'swap',
//   fontWeight: 400,
//   src: `
//     local('SonnyCond'),
//     local('SonnyCond-Regular'),
//     url(${SonnyCondRegular}) format('woff2')
//   `,
//   unicodeRange: engUnicodeRange,
// };

// const promptRegular = {
//   fontFamily: 'Prompt',
//   fontStyle: 'normal',
//   fontDisplay: 'swap',
//   fontWeight: 400,
//   src: `
//     local('Prompt'),
//     local('Prompt-Regular'),
//     url(${PromptRegular}) format('truetype')
//   `,
//   unicodeRange: thaiUnicodeRange,
// };

// Create a theme instance.
let myTheme = createMuiTheme({
  typography: {
    fontFamily: [
      'Sonny',
      'Prompt',
    ].join(','),
  },
  // overrides: {
  //   MuiCssBaseline: {
  //     '@global': {
  //       '@font-face': [
  //         sonnyCondRegular,
  //         promptRegular,
  //       ],
  //     },
  //   },
  // },
  palette: {
    primary: {
      main: '#182D43',
    },
    secondary: {
      main: '#19857b',
    },
    success: {
      main: green[400],
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    black: {
      main: '#000000',
    },
  },
  table: {
    row: {
      th: {
        background: '#F4F7FC',
      },
      odd: {
        background: '#F4F7FC',
      },
    },
  },
  primary: '#182D43',
  success: '#219653',
  error: '#E10050',
  warning: '#FFAA05',
  disabled: '#6D6D6D',
  info: '#3880ff',
  plantStatus: {
    normal: {
      chartColor: green[800],
    },
    faulty: {
      chartColor: red[600],
    },
    disconnect: {
      chartColor: amber[700],
    },
    underConstruction: {
      chartColor: grey[600],
    },
    unknown: {
      chartColor: grey[600],
    },
    disabled: {
      chartColor: grey[300],
    },
    other: {
      chartColor: grey[600],
    },
  },
  chart: {
    yellow: '#FBD872',
    orange: '#E87722',
    navy: '#182D43',
    coolGrey: '#53565A',
    blue: '#5DA3B2',
    background: '#FFFFFF',
  },
  pantoneCoolGray11C: '#53565a',
  pantone646C: '#5E8AB4',
  pantone2159C: '#4E769C',
  pantone2156C: '#8BA6C1',
  pantone158C: '#E87722',
  pantone2219C: '#5DA3B2',
  pantone7588C: '#7B4D35',
  pantone2214C: '#2F6F7A',
  pantone167C: '#BE531C',
  hex5A6FC0: '#5A6FC0',
  hex757575: '#757575',
  hex2E7D32: '#2E7D32',
  microInverterPowerLabel: '#F19E44',
});

myTheme = responsiveFontSizes(myTheme);

export const theme = myTheme;

// export const styledTheme = {
//   colors: {
//     primary: '#182D43',
//   },
// };

export default {
  theme,
  // styledTheme,
};
